import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    // DISABLED: Cart limiting functionality commented out to allow multiple athletes
    // this.#checkAndCleanupCart();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  /*
   * DISABLED: Cart limiting functionality commented out to allow multiple athletes
   *
  async #checkAndCleanupCart() {
    if (this.dataset.limitCartToOneProduct !== 'true') {
      return;
    }
    if (this.#isCleaningUp) {
      return;
    }
    this.#isCleaningUp = true;
    try {
      await new Promise(resolve => setTimeout(resolve, 150));
      const response = await fetch('/cart.js');
      const cart = await response.json();
      if (!cart.items || cart.items.length <= 1) {
        return;
      }
      const newestItem = cart.items[cart.items.length - 1];
      const updates = {};
      cart.items.forEach((item, index) => {
        if (index < cart.items.length - 1) {
          updates[item.key] = 0;
        }
      });
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });
      if (updateResponse.ok) {
        this.dispatchEvent(new CartUpdateEvent({}, 'cart-drawer-cleanup'));
      }
    } catch (error) {
      console.error('[Limit Cart - Drawer] Error:', error);
    } finally {
      this.#isCleaningUp = false;
    }
  }
  */
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
